const build = `module stripe.com/docs/payments/checkout

go 1.13

require github.com/stripe/stripe-go/v71 v71.48.0
`;

export default {
  build,
};
